<template>
  <div :class="`drawer-container ${wrapperState}`" @click.self="handleClose">
    <div :class="`drawer ${wrapperState}`">
      <div class="drawer__indicator" @click="$emit('toggle')" />
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    open: { type: Boolean, default: false },
  },
  computed: {
    wrapperState() {
      return !this.open ? '--closed' : '--open';
    },
  },
  methods: {
    handleClose() {
      this.$emit('close', this.$event);
    }
  }
};
</script>

<style lang="scss" scoped>

.drawer-container {
  position: absolute;
  width: 100vw;
  max-height: 100vh;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  left: 0;
  bottom: -100%;
  transition: all 0.3s ease-in;

  &.--closed {
    transition: all 0.3s ease-in 0.3s;
    bottom: -100%;
  }

  &.--open {
    top: 0;
    z-index: 100;
    max-width: 576px;
  }
}
.drawer {
  bottom: 0%;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  width: 100%;
  background: white;
  height: fit-content;
  min-height: 268px;
  padding: 24px;
  border-radius: 8px 8px 0 0;
  will-change: bottom;
  transition: all 0.3s ease-in;
  box-shadow: 0px 0px 8px rgba(0,0,0,0.3);

  &.--closed {
    bottom: -100%;
  }

  &.--open {
    transition: all 0.3s ease-in 0.3s;
    bottom: 0%;
  }

  &__indicator {
    width: 32px;
    height: 4px;
    border-radius: 6px;
    background: #1616163d;
    cursor: pointer;
    margin: 0 0 24px 0;
  }
}
</style>
